import { deepClone, formatNumberToThousands } from '@/utils'
import { stopBubble } from '@/utils/commonUtil'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import { exportExcel } from '@/utils/tableDataExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { advancedQuery, isContractExpiredForbidCreateJob, splitMaster, queryLastModifyBookingByDay } from '@/api/railwayExport/reBooking'
import {
  validateJobForDelete,
  batchDeleteJob,
  validateChargeLockStatus,
  batchManagerCommit,
  batchReturnSubmit, batchModifyChargeLockStatus, batchModifyPodInfo, updateJobCustomJobType
} from '@/api/booking/job'
import {
  getJobSopStates, getTrackingListByLob, getTrackingDetailByTrackingUuid, canBatchShutout, batchShutout,
  batchTransship, statisticsJobs, batchPreCommit, batchCommit, checkChargeStateVerify, batchCheckRemoveCharge, batchRemoveCharge
} from '@/api/seaExport/seaExportJob'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { cache, cacheName } from '@/utils/cacheManager'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { recordSelectedStatus } from '@/utils/agGrid'
import { workflowActionBatch } from '@/api/workflow'
import {
  APPLICATION_DIMENSION_JOB_CHARGE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { LOG_RE_RAILWAY_BOOKING, OPERATE_PRINT_RETURN } from '@/class/cargo/model/parameters/SystemConstants'
import lodash from 'lodash'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as RailwayExportConstants from '@/class/cargo/model/parameters/RailwayExportConstants'
import URL from '@/api/urlTranslator'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { getInstructions } from '@/api/sysManage/uiCustom'

export default {
  methods: {
    // 加载指令按钮
    async loadInstructionButtons() {
      await Promise.all([
        getInstructions({
          module: UICustomConstants.RAILWAY_BOOKING_MODULE,
          branchId: this.$store.getters.currentOfficeId,
          useHqSet: true,
          lob: 'RE'
        }).then(res => { this.reInstructioinBtns = res.data }),
        getInstructions({
          module: UICustomConstants.RAILWAY_BOOKING_MODULE,
          branchId: this.$store.getters.currentOfficeId,
          useHqSet: true,
          lob: 'RI'
        }).then(res => { this.riInstructioinBtns = res.data })
      ])
    },
    // 查询[简单查询/高级查询]
    toQuery(saveJobNos, removedJobNos) {
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.toBackQuery(saveJobNos, removedJobNos)
        return
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = this.handleConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(filter.conditions)
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      filter.fba = this.isFba
      filter.appendQuery = this.appendQuery
      if (this.isBpmEnabled) {
        filter.requires = ['bpm']
      }
      const loading = getLoading4Cxt(this)
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(filter).then(res => {
        const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        let results = res.data.list
        if (this.appendQuery) { // 追加查询数据去重
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
          this.total = results.length
        } else {
          this.pageNum = res.data.pageNum
          this.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
          this.pageCount = res.data.pages
        }
        this.rowData = SopUtil.resolveSopState(results)
        if (this.gridApi) this.gridApi.clearFocusedCell()
        selectedStatus.revert()
      }).finally(() => {
        this.notRefresh = false
        loading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = []
        for (const c of SystemConstants.JOB_STATES) {
          jobStates.push(c.code)
        }
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('job.CUSTOM_JOB_TYPE', data)) {
        const option = AdvancedSearchOption.removeOption('job.CUSTOM_JOB_TYPE', data)
        const customJobType = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'uuid', option.value)
        if (customJobType) {
          option.value = [customJobType.type, customJobType.code]
        }
        // 重新加入
        data.push(option)
      }
      const lcOption = AdvancedSearchOption.removeOption('job.localSevice', data)
      if (lcOption) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
          if (service) {
            services.push(service)
          }
        }
        const stuffingTypes = this.filterStuffingType(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }
      return data
    },
    filterStuffingType(items) {
      if (items.length > 0) {
        if (items.length > 1 && this.isSelfDeliveryExits(items)) {
          // 如果存在自拉自送则删除内装箱和门点装箱
          for (let i = items.length - 1; i >= 0; --i) {
            const stuffyType = items[i]
            if (stuffyType.code === 'IS' || stuffyType.code === 'DD') {
              items.splice(i, 1)
            }
          }
        }
        return this.convertStuffyTypeToQuery(items)
      }
      return []
    },
    isSelfDeliveryExits(items) {
      for (const stuffyType of items) {
        if (stuffyType.code === 'SD') {
          return true
        }
      }
      return false
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.WAREHOUSING')
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'CT') {
          result.push('reJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('reJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('reJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 返回查询
    toBackQuery(jobs, removedJobs) {
      setTimeout(() => {
        this.backHandleQueryData(jobs, removedJobs)
      })
    },
    backHandleQueryData(results, removedJobs) {
      let hasNew = false // 是否有新增数据
      for (const item of results) {
        const index = this.rowData.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.rowData[index] = item
        } else {
          this.rowData.push(item)
          hasNew = true
        }
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (removedJobs.findIndex(p => p.uuid === this.rowData[i].uuid) >= 0) {
          this.rowData.splice(i, 1)
        }
      }
      if (hasNew || removedJobs.length > 0) {
        /* 记录勾选项 */
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          const keys = Array.from(rows, p => p.uuid)
          setTimeout(() => {
            const masterSelectedSet = new Set()
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (keys.includes(node.data.uuid)) {
                node.setSelected(true)
                if (node.data.masterFlag) {
                  masterSelectedSet.add(node.data.uuid)
                }
              } else {
                if (node.data.lclMasterUuid && masterSelectedSet.has(node.data.lclMasterUuid)) {
                  setTimeout(() => {
                    node.setSelected(false)
                  })
                }
              }
            }
          }, 100)
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        for (const item of results) {
          const node = nodes.find(p => p.data.uuid === item.uuid)
          node.setData(item)
        }
        // this.gridApi.resetRowHeights()
      }
    },
    // 业务编号右边放大镜图标点击事件处理
    showBusinessInfo(e) {
      stopBubble(e)
      this.templateSelectorDialog.ctx = new RailwayExportJob(this.selectedRow)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedRow.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 查看
    async toLook(row) {
      const action = row && Number(cache.config.get('JobDirectEditingStatus')) === 1 && row.jobState === 0 && !JobUtils.isBlockJob(row) && (await SecurityUtil.canEdit(new RailwayExportJob(row))) ? 'edit' : 'look'
      this.$emit(action, row || this.selectedRow)
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 编辑
    toEdit() {
      this.$emit('edit', this.selectedRow)
    },
    // 拆分主票
    toSplit() {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      const jobKeys = [] // 已加入主票的小票uuids
      for (const item of this.selectedRows) {
        if (item.lclMasterUuid) {
          jobKeys.push(item.uuid)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessCanBeSplit'))
        return
      }
      const params = {
        jobKeys: jobKeys,
        splitPattern: 0 // 拆分模式：0.选择小票拆分 1.按装箱信息拆分
      }
      splitMaster(params).then(res => {
        const newSplitJob = res.data
        this.$logger.log('=====newSplitJob=====', newSplitJob)
        this.$logger.log('=====newSplitJob.seaEQ=====', newSplitJob.seaEQ)
        this.$logger.log('=====newSplitJob.lclSlaves=====', newSplitJob.lclSlaves)
        if (!newSplitJob || !newSplitJob.seaEQ || newSplitJob.seaEQ.length === 0) {
          this.$message.warning(this.$t('Message.SplittingErrorContainerInformationIsEmpty'))
          return
        }
        this.$emit('split', newSplitJob)
      })
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      if (this.loading) {
        this.loading.close()
      }
    },
    beforeFbaOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 单个导入上传成功
    uploadSingleOrderSuccess(res, file, fileList) {
      console.log('uploadOrderSuccess', res)
      const { data } = res
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
    },
    // 复制
    toCopy() {
      const jobList = this.selectedRows
      if (!jobList || jobList.length <= 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      if (jobList.length > 1) {
        this.$message.warning(this.$t('Message.SelectOneJob'))
        return
      }
      const usefulJob = jobList[0]
      if (usefulJob.customerId) {
        const loading = getLoading4Cxt(this)
        isContractExpiredForbidCreateJob(usefulJob.customerId).then(res => {
          loading.close()
          if (res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.$emit('copy', usefulJob)
          }
        }).catch(() => {
          loading.close()
        })
      }
    },
    // 删除
    async toDelete() {
      const rows = this.selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState > 0) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('Message.IsNotOperationStatus'))
          return
        }
      }
      const jobKeys = []
      for (const row of rows) {
        jobKeys.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      const res = await validateJobForDelete({ keys: jobKeys }).finally(() => {
        loading.close()
      })
      this.handlerDelete(res.data, jobKeys)
    },
    // 删除验证结果
    handlerDelete(delMap, jobKeys) {
      if (!delMap.canDelete) {
        if (delMap.hasDelete) {
          this.$message.warning(this.$t('CargoMsg.HasDeletedForDeleteJob'))
        }
        if (delMap.existsSlaveJob) {
          this.$message.warning(this.$t('CargoMsg.HasSlaveJobForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsCharge) {
          this.$message.warning(this.$t('CargoMsg.HasChargeForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsMergeJob) {
          this.$message.warning(this.$t('CargoMsg.HasMergeForDeleteJob', [delMap.jobNo]))
        }
        return
      }
      this.$confirm(this.$t('Message.SureDeleteThese') + jobKeys.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(async() => {
        const loading = getLoading4Cxt(this)
        try {
          const res = await batchDeleteJob({ jobKeys: jobKeys, location: this.location })
          await this.handlerDeleteResult(res)
        } finally {
          loading.close()
        }
      }).catch(() => { })
    },
    // 删除成功处理
    async handlerDeleteResult(res) {
      const result = res.data
      if (result > 0) {
        const rows = this.selectedRows
        for (const row of rows) {
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
          if (row.lclMasterUuid) {
            const masterJob = this.rowData.find(p => p.uuid === row.lclMasterUuid)
            if (masterJob) {
              await new RailwayExportJob(masterJob).loadJobRelated({ job: true })
            }
          }
        }
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
      }
    },
    // 导出公共
    exportHandle() {
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      switch (this.exportCommand) {
        case this.$t('SeaExport.ExportToExcel'):
          this.toExportToExcel()
          break
        case this.$t('SeaExport.ExportWithSOPToExcel'):
          this.toExportWithSOPToExcel()
          break
      }
    },
    // 导出Excel
    toExportToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const newRows = deepClone(this.selectedRows)
      this.toExport(newRows, allDisplayedColumns)
    },
    // 导出Excel(含SOP明细)
    async toExportWithSOPToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // copy一个新的
      const newRows = deepClone(this.selectedRows)
      if (!newRows || newRows.length <= 0) return
      const jobKeys = Array.from(newRows, p => p.uuid)
      let jobSopStates = {}
      await getJobSopStates(jobKeys).then(res => {
        jobSopStates = res.data
      })
      // 查询海运出口的所有SOP节点
      const sopTemplateMap = await SopUtil.getSopTemplateMap(newRows)
      const headerNameMap = new Map()
      const sopColumns = []
      // 循环每条业务数据
      for (let i = 0; i < newRows.length; i++) {
        const reJob = newRows[i] // 当前行
        if (!sopTemplateMap.hasOwnProperty(reJob.trackingTemplateUuid)) {
          continue
        }
        const trackMap = sopTemplateMap[reJob.trackingTemplateUuid]
        const newSopState = (jobSopStates && Object.prototype.hasOwnProperty.call(jobSopStates, reJob.uuid)) ? jobSopStates[reJob.uuid] : ''
        const currentJobSopState = !newSopState ? reJob.sopState : newSopState // 当前行的SOP数据

        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          if (trackMap.hasOwnProperty(columnName)) {
            const track = trackMap[columnName]
            if (track && (Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_E.code) || Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_SUPPLEMENT.code))) {
              continue
            }
          }
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? this.$t('Message.NotStart') : oldColumnValue
          //
          if (!headerNameMap.has(columnName)) {
            headerNameMap.set(columnName, columnValue)
            sopColumns.push({ headerName: columnName, field: columnName, columnType: 'SOP' })
          }
          newRows[i][columnName] = columnName + ' ' + columnValue
        }
      }
      // 获取所有列
      const allColumns = [...allDisplayedColumns, ...sopColumns]
      this.toExport(newRows, allColumns)
    },
    toExport(rows, columns) {
      const fileName = 'REBookingList'
      exportExcel(fileName, rows, columns)
    },
    // 修改SOP状态
    editState() {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAJob'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      let lob = null
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
      })
      this.stateDialog.rows = this.selectedRows
      this.stateDialog.visible = true
    },
    // 退关
    toShutOut() {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      const jobKeys = []
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.IsNotOperationStatusCannotBeShutOut'))
          return
        }
        // 财务审核
        if (item.jobState === 2) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
          return
        }
        // 退关
        if (item.shutOut) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenShutOuted'))
          return
        }
        jobKeys.push(item.uuid)
      }
      this.shutOutDialog.jobKeys = jobKeys
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    },
    // 验证退关
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      this.shutOutDialog.shutOutButtonShow2 = ''
      if (result === 0) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.CustomsClearanceNoChargeNoChange')
      } else if (result === 1) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.ClearFeeNoChargeCustomsClearance')

        this.shutOutDialog.shutOutButtonShow2 = 'none'
      } else if (result === 2) {
        this.$message.warning(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.warning(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
      if (result === 0 || result === 1) {
        this.shutOutDialog.visible = true
      }
    },
    // 有费用退关
    hasChargeShutoutHandler() {
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      const hasCharge = true
      this.shutOutDialog.hasCharge = hasCharge
      batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res))
    },
    // 无费用退关
    async noHasChargeShutoutHandler() {
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      const hasCharge = false
      this.shutOutDialog.hasCharge = hasCharge
      const checkNode = CheckRuleConstants.NO_FEE_REFUND.code
      const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, this.selectedRows[0].lob)
      if (hasCheckRule) {
        const callBack = async() => { batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res)) }
        this.checkingManager(this.selectedRows, checkNode, callBack, null)
      } else {
        batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res))
      }
    },
    // 退关处理结果
    batchShutoutResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.$message.success(this.$t('Message.ShutOutSuccessfully') + ': ' + len)
      this.shutOutDialog.visible = false
      if (len === 0) {
        return
      }
      const objJobKey = {}
      const jobKeys = this.shutOutDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }
      for (const reJob of this.rowData) {
        if (objJobKey.hasOwnProperty(reJob.uuid) && objJobKey[reJob.uuid] === reJob.uuid) {
          const hasCharge = this.shutOutDialog.hasCharge
          reJob.shutOut = true
          if (!hasCharge) {
            reJob.jobState = SystemConstants.SHUT_OUT
          }
        }
      }
      this.shutOutDialog.hasCharge = false
      this.shutOutDialog.jobKeys = []
      this.gridApi.refreshCells({ force: true })
    },
    // 批量打印
    onBatchPrint(command) {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      if (jobKeys.length > 0) {
        this.templateSelectorDialog.ctx = new RailwayExportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'JOBLIST_RE'
        this.templateSelectorDialog.data = {
          'JOB_UUID': jobKeys,
          'printSource': DocumentConstants.BATCH_PRINT_RE.code
        }
        // 是否按照多个打印
        if (command === this.$t('queryJob.PrintByBusinessNumber')) {
          Object.assign(this.templateSelectorDialog.data, {
            'JOB_UUID': jobKeys[0],
            multiplePrint: true,
            multipleJobUuid: jobKeys
          })
        }
        this.templateSelectorDialog.visible = true
      }
    },
    // 批量转船
    toBatchTransship() {
      if (this.selectedRows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      this.toInitClearCheckBox()
      this.toInitTransshipDialog()
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(item.jobState) === Number(SystemConstants.OPERATING)) {
          this.transshipDialog.jobKeys.push(item.uuid)
          this.transshipDialog.selectedJobs.push(item)
        }
      }
      const jobs = this.transshipDialog.selectedJobs
      if (jobs.length > 0) {
        let flag = true
        // 判断在订舱性质是否在同一条船,是否是同一个航次
        const voyageFlight = jobs[0].voyageFlight
        const vessel = jobs[0].vessel
        for (const reJob of jobs) {
          if (reJob.voyageFlight !== voyageFlight || reJob.vessel !== vessel) {
            this.$message.warning('所选单据不是同一个班车/车次')
            flag = false
            return
          }
        }
        if (flag) {
          this.transshipDialog.isDBFlag = true
          this.transshipDialog.visible = true
        }
      } else {
        this.$message.warning(this.$t('SeaExport.AllNotPositiveOperationStatus'))
      }
    },
    // 初始化批量转船对话框数据
    toInitTransshipDialog() {
      this.transshipDialog.selectedJobs = []
      this.transshipDialog.isDBFlag = true
      this.transshipDialog.txtVessel = ''
      this.transshipDialog.txtVoyage = ''
      this.transshipDialog.txtVessel_1 = ''
      this.transshipDialog.txtVoyage_1 = ''
      this.transshipDialog.dfETD = ''
      this.transshipDialog.txtPortAgent = ''
      this.transshipDialog.jobKeys = []
      this.transshipDialog.transship = {}
    },
    // 批量转船点击确定
    transShipClickHandler() {
      const jobs = this.transshipDialog.selectedJobs
      if (jobs && jobs.length > 0) {
        const isDBFlag = this.transshipDialog.isDBFlag
        const obj = {}
        obj.jobKeys = this.transshipDialog.jobKeys
        if (!isDBFlag) {
          if (this.transshipDialog.txtVessel !== '') {
            obj.vessel = this.transshipDialog.txtVessel
          } else {
            if (this.clearCheckBox.vessel) {
              obj.vessel = ''
            }
          }
          if (this.transshipDialog.txtVoyage !== '') {
            obj.voyage = this.transshipDialog.txtVoyage
          } else {
            if (this.clearCheckBox.voyage) {
              obj.voyage = ''
            }
          }
        } else {
          if (this.transshipDialog.txtVessel_1 !== '') {
            obj.vessel = this.transshipDialog.txtVessel_1
          } else {
            if (this.clearCheckBox.vessel) {
              obj.vessel = ''
            }
          }
          if (this.transshipDialog.txtVoyage_1 !== '') {
            obj.voyage = this.transshipDialog.txtVoyage_1
          } else {
            if (this.clearCheckBox.voyage) {
              obj.voyage = ''
            }
          }
        }
        if (this.transshipDialog.dfETD !== '') {
          obj.etd = this.transshipDialog.dfETD
        }
        const portAgent = this.transshipDialog.txtPortAgent
        if (portAgent !== '' && portAgent > 0) {
          obj.portAgent = portAgent
        } else {
          if (this.clearCheckBox.portAgent) {
            obj.portAgent = 0
          }
        }
        this.transshipDialog.transship = obj
        batchTransship(obj).then(res => { this.batchTransshipResult(res) })
      }
    },
    // 处理批量转船返回结果
    batchTransshipResult(res) {
      this.$confirm(this.$t('Message.BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'success',
        closeOnClickModal: false
      }).then(() => {
        this.toQuery()
        this.transshipDialog.visible = false
      }).catch(() => {
        this.toQuery()
      })
    },
    // 统计
    async toStatistics() {
      this.statisticsClean()
      const loading = getLoading4Cxt(this)
      try {
        await this.handleStatistics(false)
        this.statisticsDialog.visible = true
      } finally {
        loading.close()
      }
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      let rows = this.gridApi.getSelectedRows().filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      if (rows.length === 0) {
        rows = this.rowData.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('Message.PleaseSelectAJob'))
      }
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      let lob = ''
      // 列表勾选的数据是否都为”已退关“
      let allJobShutOut = true
      for (const job of rows) {
        if (!job.shutOut) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.shutOut) {
          // 弹窗手动修改”是否包含退关“
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        count++
        if (lob === '') lob = job.lob
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          weight += isNaN(job.weightActual) ? 0 : job.weightActual
          cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
          chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 3)
      this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 3)
      this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 3)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      await statisticsJobs({ jobKeys: jobKeys, lob: 'RE', containShutOutJob: this.statisticsDialog.containShutOutJob }).then(res => this.statisticsJobsResult(res.data))
    },
    // 清空统计对话框
    statisticsClean() {
      for (const key in this.statisticsDialog) {
        this.statisticsDialog[key] = ''
      }
      this.statisticsDialog.containShutOutJob = false
    },
    // 统计结果
    statisticsJobsResult(res) {
      if (res) {
        this.statisticsDialog.txt20 = res.b20
        this.statisticsDialog.txt40 = res.b40
        this.statisticsDialog.txt40hq = res.b40h
        this.statisticsDialog.txt45 = res.b45
        this.statisticsDialog.txtTeu = res.teu
      } else {
        this.statisticsDialog.txt20 = 0
        this.statisticsDialog.txt40 = 0
        this.statisticsDialog.txt40hq = 0
        this.statisticsDialog.txt45 = 0
        this.statisticsDialog.txtTeu = 0
      }
    },
    // 批量提交
    async toBatchSubmit() {
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      const paramsBpm = []
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        if (!item.masterFlag && !item.lclMasterUuid && (item.containerLoadType === 'LCL' || item.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
        // 构建bpm请求参数
        const paramBpm = {
          documentConfigId: Job_CHARGE.code,
          docId: item.uuid,
          docNo: item.jobNo,
          actionType: 7000,
          officeId: item.opOffice,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
        }
        paramsBpm.push(paramBpm)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of this.selectedRows) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        const opOffice = (selectedJobs && selectedJobs.length > 0) ? selectedJobs[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
          this.paramsBpm = paramsBpm
          this.opOffice = selectedJobs[0].opOffice
          if (this.allowPartialCheckPass) {
            const callBack = () => { this.batchCommitCall() }
            this.checkingManager(selectedJobs, checkNode, callBack, null, true)
          } else {
            const callBack = () => { this.batchCommitCall() }
            this.checkingManager(selectedJobs, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('queryJob.AreTicketsSubmitted'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(async() => {
            if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: selectedJobs[0].opOffice })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            const officeId = this.$store.getters.currentOfficeId
            batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }).catch(() => { })
        }
      }
    },
    // 批量提交回调
    async batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        // 过滤有效keys
        this.paramsBpm = this.paramsBpm.filter(paramBpm => jobKeys.indexOf(paramBpm.docId) !== -1)
        if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: this.opOffice })) {
          WorkflowUtil.jobBatchCommitBpm(this, this.paramsBpm)
          return
        }
        const officeId = this.$store.getters.currentOfficeId
        batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
      }
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
        this.$logger.log('预提交——jobKeys：', jobKeys)
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.toQuery()
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.toQuery()
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
    },
    // 批量预提交
    toBatchPreSubmit() {
      const jobKeys = []
      for (const j of this.selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(j.uuid)
      }
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res))
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const rows = this.selectedRows
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = () => { this.batchPreCommitCall() }
            this.checkingManager(rows, checkNode, callBack, null, true)
          } else {
            const callBack = () => { this.batchPreCommitCall() }
            this.checkingManager(rows, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      const selectedJobs = []
      for (const obj of this.selectedRows) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      // if (!await this.validateChargeLocked(selectedJobs)) return
      // this.addChargeDetailDialog.selectedJobs = selectedJobs
      // this.addChargeDetailDialog.visible = true
      this.chargeTypeDialog.type = this.role.addPayableChargeRole ? 2 : 1
      this.chargeTypeDialog.selectedJobs = selectedJobs
      this.chargeTypeDialog.visible = true
    },
    onChargeTypeDialogConfirm() {
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.chargeTypeDialog.selectedJobs
      if (!rows || rows.length === 0) return
      if (type === 0) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ARAP_Locked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      } else if (type === 1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
      } else if (type === 2) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      }

      if (this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        if (type === 0 || type === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AR'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && this.role.addPayableChargeRole) {
        if (type === 0 || type === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AP'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Cannot_Add_Charge'))
        return
      }

      if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, type, rows, this)) {
        return
      }
      this.addChargeDetailDialog.selectedJobs = rows
      this.addChargeDetailDialog.type = type
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      const selectedJobs = []
      for (const obj of this.selectedRows) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessOrIsNotOperationalState'))
        return
      }
      if (!await this.validateChargeLocked(selectedJobs)) return
      this.editChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.editChargeDetailDialog.selectedJobs = selectedJobs
      this.editChargeDetailDialog.visible = true
    },
    // 删除费用（待优化，两个接口可以合并成一个接口）
    async toDeleteCharge() {
      const selectedJobs = []
      const jobKeys = []
      const jobs = this.gridApi.getSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          jobKeys.push(obj.uuid)
          selectedJobs.push(obj)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.deleteChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.deleteChargeDetailDialog.selectedJobs = selectedJobs
      this.deleteChargeDetailDialog.visible = true
    },
    // 删除费用处理结果
    batchCheckRemoveChargeResult(res) {
      const canDeleteChargeKeys = res.data
      if (canDeleteChargeKeys && canDeleteChargeKeys.length > 0) {
        batchRemoveCharge(canDeleteChargeKeys, this.location).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
          } else {
            this.$message.error(this.$t('RailwayExport.OperationFailed'))
          }
        })
      } else {
        this.$message.warning(this.$t('Message.NoCostToRemove'))
      }
    },
    // 验证费用锁定状态
    async validateChargeLocked(jobs) {
      if (jobs && jobs.length > 0) {
        let pass = true
        const keys = []
        for (const item of jobs) {
          if (item.uuid) {
            keys.push(item.uuid)
          }
        }
        await validateChargeLockStatus(keys).then(res => {
          pass = res.data
        }).catch()
        if (!pass) {
          this.$message.warning(this.$t('SeaExport.ChargeLocked'))
          return false
        }
      }
      return true
    },
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      const loading = getLoading4Cxt(this)
      this.filterJson = {}
      this.filterJson.pageNum = this.pageNum
      this.filterJson.pageSize = this.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.modifiedBy = this.$store.getters.userId
      this.filterJson.fba = this.isFba
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      queryLastModifyBookingByDay(this.filterJson).then(res => {
        this.rowData = SopUtil.resolveSopState(res.data.list)
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.pageCount = res.data.pages
        if (this.gridApi) this.gridApi.clearFocusedCell()
      }).finally(() => {
        loading.close()
      })
    },
    // 批量操作
    batchHandle(val) {
      if (val !== 3) {
        if (this.hierarchyViewList) {
          if (val !== 5) {
            this.checkOwnerBranch(this.selectedRows)
          }
        }
      }
      switch (val) {
        case 1:
          this.toBatchPreSubmit()
          break
        case 2:
          this.toBatchSubmit()
          break
        case 3:
          this.toBatchManagerSubmission()
          break
        case 4: // 批量撤回预提交
          this.toBatchReturnPreSubmit()
          break
        case 5: // 批量退回提交
          this.toBatchReturnSubmit()
          break
        case 6:
          // 批量锁定应收费用
          this.toBatchModifyChargeLockingStatus(true)
          break
        case 7:
          // 批量锁定应付费用
          this.toBatchModifyChargeLockingStatus(false)
          break
        case 8:
          this.toBatchModifyPodInfo()
          break
        case 9:
          this.toBatchUpdateCustomType()
          break
        case 17:
          this.toBatchModifyBusiness()
          break
        case 18:
          this.toBatchUpdateSopTemplate()
          break
        case 19:
          this.toBatchCooperation()
          break
        case 20:
          JobUtils.toBatchFillGpExplain(this.selectedRows, this.gpExplain)
          break
        case 21:
          JobUtils.batchLockJobHandler(this, this.selectedRows, true, this.toQuery)
          break
        case 22:
          JobUtils.batchLockJobHandler(this, this.selectedRows, false, this.toQuery)
          break
        case 24:
          JobUtils.batchReturnReview(this, this.selectedRows)
          break
      }
      if (typeof val === 'string') {
        if (val.startsWith('instruction,')) {
          const args = val.split(',')
          const lob = args[1]
          const tenantInstructionUuid = args[2]
          let item = null
          if (lob === 'RE') {
            item = this.reInstructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          } else {
            item = this.riInstructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          }
          if (item) {
            const rows = this.readSelectedRows().filter(row => row.lob === lob)
            if (rows.length === 0) {
              this.$message.warning(lob === 'RE' ? this.$t('SystemMaintenance.PleaseSelectRailwayExportServices') : this.$t('SystemMaintenance.PleaseSelectRailwayImportBusiness'))
              return
            }
            if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
              if (!this.$store.getters.isGroupCompany) {
                this.$message.warning(this.$t('SystemMaintenance.NonNotSupportCrossTenants'))
                return
              }
              this.$refs.tenantEntrustWindow.onShowOfUI(item, rows)
            }
          }
        }
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionButtons()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
        this.toQuery()
      }
    },
    // 批量锁定应收/应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new RailwayExportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回提交
    async toBatchReturnSubmit() {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.COMMITED)) {
          this.$message.warning(this.$t('SeaExport.BatchReturnSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Withdraw') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'RE', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.toQuery()
            }
            this.$message.success(this.$t('SeaExport.SuccessWithdraw', [res.data ? res.data.length : 0]))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回预提交
    async toBatchReturnPreSubmit() {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchReturnPreSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_RETURN_ACTION.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Return') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'RE', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) this.toQuery()
            this.$message.success(this.$t('Message.AlreadyReturn'))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      let rows = []
      let jobKeys = []
      for (const j of this.selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
          if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
            this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }
      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of this.selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          const callBack = this.batchBatchManagerSubmissionCall || null
          this.checkingManager(rows, checkNode, callBack, null, this.allowPartialCheckPass)
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {
          })
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.toQuery()
    },
    // 导出导入订单模板
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.Add'):
          this.toAdd()
          break
        case this.$t('SeaExport.import'):
          if (!this.isFba) {
            this.importHandle()
          }
          break
        case this.$t('FbaJob.batchImportOrder'):
          this.$refs.uploadBatchOrder.submit()
          break
        case this.$t('FbaJob.importSingleOrder'):
          this.$refs.uploadSingleOrder.submit()
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate'):
          this.downloadTemplate()
          break
        case this.$t('FbaJob.downloadBatchImportTemplate'):
          this.downloadBatchImportTemplate()
          break
        case this.$t('FbaJob.downloadSingleImportTemplate'):
          this.downloadSingleImportTemplate()
          break
      }
    },
    // 选则业务类型
    importHandle() {
      this.importJobLobDialog.lob = 'RE'
      this.importJobLobDialog.visible = true
    },
    beforeOrderUpload(file) {
      this.importJobLobDialog.visible = false
      this.importJobLobDialog.lob = 'RE'
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      if (this.loading) {
        this.loading.close()
      }
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    // 下载导出订单模板
    downloadTemplate() {
      // ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'RB')
      // CARGO-39209 各个业务类型批量导入模板中，各模板加入样例文件
      this.downloadImportTemplateDialog.visible = true
    },
    // 下载铁路头程批量导入模板
    downloadBatchImportTemplate() {
      // ExportUtils.downloadTemplateFile('ImportBatchRailwayFbaOrders.xlsx', 'fba')
      ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'FBA_RE')
    },
    // 下载铁路头程单个导入模板
    downloadSingleImportTemplate() {
      ExportUtils.downloadTemplateFile('ImportOneRailwayFbaOrder.xlsx', 'fba')
    },
    // 批量修改目的港信息
    toBatchModifyPodInfo() {
      const rows = this.selectedRows
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
      }
      for (const key in this.podInfo) {
        if (key === 'visible') continue
        this.podInfo[key] = ''
      }
      this.podInfo.keys = Array.from(rows, p => p.uuid)
      this.podInfo.visible = true
    },
    // 确认批量修改目的港信息
    confirmBatchModifyPodInfo() {
      const param = {}
      for (const key in this.podInfo) {
        if (key === 'visible') continue
        if (this.podInfo[key]) { // 有值处理，无值不处理
          param[key] = this.podInfo[key]
        }
      }
      if (Object.keys(param).length <= 1) {
        return
      }
      param.lob = 'RE'
      this.loading = getLoading4Cxt()
      batchModifyPodInfo(param).then(res => {
        if (res.data && res.data > 0) {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.podInfo.visible = false
          return
        }
        this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 组装查询条件
    async getCustomSearchItems() {
      const defaultSearchFields = []
      let searchField = new AdvancedSearchField()
      if (this.useOrderCenterMode && this.orderCenterBranch) {
        // 协作分公司
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1) // 其他分公司
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作任务创建时间
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'cooperate.DATE_CREATED'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateCreatedDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'includeAllOffice': this.conditonDisplayAllBranchData
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
      // 自定义业务类型
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'cutomJobType'
      searchField.subType = 'RE'
      searchField.fieldType = 'FIELD_CUTOM_JOB_TYPE_RE'
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'job.CUSTOM_JOB_TYPE'
      searchField.itemLabel = 'queryJob.customJobType'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = 'uuid'
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      // 箱型
      const boxTypes = RailwayExportConstants.RAILWAY_EXPORT_BOX_TYPES.map(item => {
        return { code: item.code, chineseName: item.chineseName, englishName: item.englishName }
      })

      defaultSearchFields.push(JobUtils.createSearchField(boxTypes, 'seaEq.EQSIZE', 'SeaExport.BoxModel'))

      // 箱种
      const eqTypes = getCacheListByKey(TYPE_NAMES.basic_data_EQType)
      const eqTypeList = eqTypes && Array.isArray(eqTypes)
        ? eqTypes.map((eqType) => ({
          code: eqType.code,
          chineseName: eqType.code,
          englishName: eqType.name
        })) : []

      defaultSearchFields.push(JobUtils.createSearchField(eqTypeList, 'seaEq.EQTYPE', 'SeaExport.BoxSpecies'))
      // 运输类型
      const transportationTypes = getCacheListByKey(TYPE_NAMES.basic_data_TransportationType)
      const transportationTypeList = transportationTypes && Array.isArray(transportationTypes) ? transportationTypes.map((transportationType) => ({
        code: transportationType.code,
        chineseName: transportationType.chineseName,
        englishName: transportationType.englishName
      })) : []
      defaultSearchFields.push(JobUtils.createSearchField(transportationTypeList, 'reJob.TRANSPORT_TYPE', 'SeaExport.TransportType'))
      // 付款方式
      const paymentMethods = getCacheListByKey(TYPE_NAMES.basic_data_PaymentMethod)
      const paymentMethodList = paymentMethods && Array.isArray(paymentMethods) ? paymentMethods.map((paymentMethod) => ({
        code: paymentMethod.code,
        chineseName: paymentMethod.chineseName,
        englishName: paymentMethod.englishName
      })) : []
      defaultSearchFields.push(JobUtils.createSearchField(paymentMethodList, 'reJob.PAYMENT_METHOD', 'Clearing.PaymentMethod'))

      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      for (const item of this.defaultSearchItems) {
        if (item.itemName === 'job.CUSTOMER_ID' && item.fieldType === 'FIELD_CUSTOMER') {
          continue
        }
        if (item.itemType === 'userSea' || item.itemType === 'user' || item.itemType === 'user2') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.officeId = ''
          }
          defaultSearchFields.push(newItem)
        } else if (item.itemType === 'company' || item.itemType === 'office' || item.itemType === 'department5') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.includeAllOffice = true
          }
          defaultSearchFields.push(newItem)
        }
      }
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        let saleProductList
        if (!this.isFba) {
          saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
            return mapping.statusEnabled === true && mapping.railwayFreight === true
          })
        } else {
          saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
            return mapping.statusEnabled === true && mapping.fbaRailway === true
          })
        }
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.hierarchyViewList) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      if (this.$store.state.uiCustom.enable && !this.isFba) {
        UICustomUtil.handleSearchItems(UICustomConstants.RAILWAY_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
      }
      return defaultSearchFields
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    async initColumnDefs() {
      // CARGO-31277 SOPSOP节点显示列增加
      const sopColumns = await SopUtil.getSopColumns('RE')
      this.columnDefs = [...this.columnDefs, ...sopColumns]
      await JobUtils.enrichTotalRevenueColumnDefs(this.columnDefs, this)
      if (this.isBpmEnabled) {
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(this.TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ContainSensitiveWord'),
            colId: 'hasSensitiveWord',
            field: 'hasSensitiveWord',
            width: 130,
            minWidth: 130,
            hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_SystemConstants$HAS_SENSIVITE_WORD, 'code', params.value, 'chineseName')
            }
          }
        )
      }
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows() {
      const allRows = this.selectedRows
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 刷新表格
    refreshAgGrid() {
      this.gridApi.refreshCells({ force: true })
      this.gridApi.redrawRows()
    },
    // 批量修改自定义业务类型
    toBatchUpdateCustomType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      const lobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.warning(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        lobList.push(j.lob)
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      // 不可以勾选包含不同业务类型的业务
      if (lobList.includes(SystemConstants.RE.code) && lobList.includes(SystemConstants.RI.code)) {
        this.$message.warning(this.$t('SeaExport.RailwayCheckLob'))
        return
      }
      this.customJobTypeDialog.jobKeys = jobKeys
      this.customJobTypeDialog.jobList = jobList
      this.customJobTypeDialog.visible = true
      this.customJobTypeDialog.lobType = lobList[0]
    },
    // 批量修改自定义业务类型点击确定
    customJobTypeClickHandler() {
      const jobs = this.customJobTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        const obj = {}
        obj.jobUuids = this.customJobTypeDialog.jobKeys
        obj.customJobType = this.customJobTypeDialog.customJobType
        this.loading = getLoading()
        updateJobCustomJobType(obj).then(res => this.updateJobCustomJobTypeResult(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 批量修改自定义业务类型 处理结果
    updateJobCustomJobTypeResult(res) {
      this.loading.close()
      if (res.data) {
        this.$message.success(this.$t('SeaExport.CustomJobTypeBatchModifySuccess') + res.data)
        for (const seaJob of this.customJobTypeDialog.jobList) {
          seaJob.customJobType = this.customJobTypeDialog.customJobType
        }
        this.refreshAgGrid()
      }
      this.customJobTypeDialog.visible = false
      this.customJobTypeDialog.customJobType = ''
      this.customJobTypeDialog.jobKeys = []
      this.customJobTypeDialog.jobList = []
    },
    // 批量修改业务
    toBatchModifyBusiness() {
      const rows = this.selectedRows
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.maxSelectBusiness', ['200']))
        return
      }
      this.batchModifyBusinessDialog.lob = 'RE'
      this.batchModifyBusinessDialog.jobList = rows
      this.batchModifyBusinessDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.batchModifyBusinessDialog.visible = true
    },
    // 批量修改业务成功后，弹窗回调
    batchModifyBusinessCallback() {
      this.toQuery()
    },
    // 批量更换SOP模板
    toBatchUpdateSopTemplate() {
      const rows = this.selectedRows
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      let lob = null
      for (const item of rows) {
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      this.changeSopTemplateDialog.lob = lob
      JobUtils.batchUpdateSopTemplate(this, rows)
    },
    // 批量发起协作
    toBatchCooperation() {
      const rows = this.selectedRows
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.batchCooperationDialog.jobList = rows
      this.batchCooperationDialog.visible = true
    },
    reload() {
      this.toQuery()
    },
    // 批量导入费用
    async toImportCharge() {
      const selectedJobs = []
      const jobs = this.selectedRows
      if (!jobs || jobs.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        } else {
          this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
          return
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      if (selectedJobs.length > 500) {
        this.$message.warning(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }

      // 将相同的委托单位、整拼类型、货物类型带入到费用方案窗口
      let isSameCustomer = true
      let isSameContainerLoadType = true
      let isSameCargoType = true
      let isSameDestinationAgent = true
      const containerLoadType = selectedJobs[0].containerLoadType
      const customerId = selectedJobs[0].customerId
      const destinationAgent = selectedJobs[0].destinationAgent
      const cargoType = selectedJobs[0].cargoType
      for (const seaJob of selectedJobs) {
        if (!this.addChargeDetailDialog.visible) {
          if (seaJob.containerLoadType !== containerLoadType) {
            this.$message.warning(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheContainerLoadType'))
            return
          }
        }
        if (customerId !== seaJob.customerId) {
          isSameCustomer = false
        }
        if (containerLoadType !== seaJob.containerLoadType) {
          isSameContainerLoadType = false
        }
        if (cargoType !== seaJob.cargoType) {
          isSameCargoType = false
        }
        if (destinationAgent !== seaJob.destinationAgent) {
          isSameDestinationAgent = false
        }
      }
      const sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameContainerLoadType) {
        sameCondition['containerLoadType'] = containerLoadType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = this.addChargeDetailDialog.visible ? this.chargeTypeDialog.type : null
      this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.isSea = false
      this.chargeSchemeBatchDialog.lob = 'RB'
      this.chargeSchemeBatchDialog.job = selectedJobs[0]
      this.chargeSchemeBatchDialog.needCheckRange = !(selectedJobs.length > 1) // 勾选了多票业务就不要用单个业务数据区间过滤费用方案
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    toInitClearCheckBox() {
      this.clearCheckBox.vessel = false
      this.clearCheckBox.voyage = false
      this.clearCheckBox.portAgent = false
    },
    clearCheckBoxChange(key = '') {
      switch (key) {
        case 'vessel':
          if (this.clearCheckBox.vessel) {
            this.transshipDialog.txtVessel = ''
            this.transshipDialog.txtVessel_1 = ''
          }
          break
        case 'voyage':
          if (this.clearCheckBox.voyage) {
            this.transshipDialog.txtVoyage = ''
            this.transshipDialog.txtVoyage_1 = ''
          }
          break
        case 'portAgent':
          if (this.clearCheckBox.portAgent) {
            this.transshipDialog.portAgent = ''
          }
          break
        default:
      }
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.readSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }
  }
}
